import { Overlay } from 'react-bootstrap';
import React from 'react';
// import PropTypes from 'prop-types';

const Popup = ({ showTelephonePopover, target, children, placement, onHide }) => (
	<Overlay
		target={target.current}
		show={showTelephonePopover}
		placement={placement}
		flip={true}
		rootClose={true}
		rootCloseEvent={'click'}
		onHide={onHide}
	>
		{({
			placement,
			scheduleUpdate,
			arrowProps,
			outOfBoundaries,
			rootClose,
			rootCloseEvent,
			onHide,
			show: _show,
			...props
		}) => <div {...props}>{children}</div>}
	</Overlay>
);

Popup.defaultProps = {
	placement: 'auto'
};

export default Popup;

